import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import spartaGlobal from "utilities/global/sparta-global-utility/5.0.2/js/sparta-global-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.7/js/sparta-ui-layers-utility";
import Utility from "utilities/community/module-utils-utility/3.0.1/js/module-utils-utility";
import _ from "vendor/lodash";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";
import "css!modules/community/es-en-interstitial/3.1.0/css/es-en-interstitial.scss.css";

const scope = {};
class esEnInterstitialTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'es-en-interstitial', precompiled: {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n";
},"useData":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new esEnInterstitialTemplates();
